<template>
  <div id="stream-chat-react">
    <div v-if="error" class="h-100 bg-white p-2">
      <p>{{ error }}</p>
      <HMButton color="brand" @click="reinitializeChat">
        {{ $t('STUDIO.BUTTON.TRY_TO_RELOAD_CHAT') }}
      </HMButton>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
import { streamChatLoaded } from '@/core/services/stream';

export default {
  name: 'HMPublicChat',
  components: {},
  props: {
    userId: {
      type: String,
      default: '',
    },
    userName: {
      type: String,
      default: '',
    },
    userImage: {
      type: String,
      default: '',
    },
    userToken: {
      type: String,
      default: '',
    },
    channelId: {
      type: String,
      default: '',
    },
    channelName: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters({
      chatClient: 'community/chatClient',
      chatUser: 'user/user',
    }),
  },
  data() {
    return {
      channel: null,
      members: [],
      error: null,
      chatListener: null,
    };
  },
  methods: {
    async reinitializeChat() {
      await this.initializeChat();
    },
    async initializeChat() {
      await streamChatLoaded();
      try {
        this.channel = this.chatClient.channel('messaging', this.channelId, {
          name: this.channelName,
        });

        await this.channel.watch();
        this.$emit('onChannelConnected', this.channel);
        this.chatListener = this.chatClient.on(this.processChatClientEvents);
        this.renderStreamChatReact();
      } catch (error) {
        console.error('error=', error);
        this.error = error;
        alert('Failed to load chat, please refresh your page!');
      } finally {
      }
    },
    processChatClientEvents(event) {
      if (event.type === 'notification.added_to_channel') {
        this.$emit('onAddedToChannel', event);
      }
      if (event.type === 'notification.removed_from_channel') {
        this.$emit('onRemovedFromChannel', event);
      }
      if (event.type === 'notification.message_new') {
        this.$emit('onNewMessage', event);
      }
      if (event.type === 'notification.mark_read') {
        this.$emit('onMarkRead', event);
      }
    },
    streamChatReactApp() {
      return React.createElement(
        React.Fragment,
        null,
        React.createElement(
          StreamChatReact.Chat,
          {
            client: this.chatClient,
            theme: 'livestream light',
          },
          React.createElement(
            StreamChatReact.Channel,
            {
              channel: this.channel,
            },
            React.createElement(
              StreamChatReact.Window,
              {
                hideOnThread: true,
              },
              React.createElement(StreamChatReact.MessageList, {
                //Message: StreamChatReact.MessageLivestream,
                Message: StreamChatReact.MessageTeam,
              }),
              React.createElement(StreamChatReact.MessageInput, null)
            ),
            React.createElement(StreamChatReact.Thread, {
              Message: StreamChatReact.MessageLivestream,
              fullWidth: true,
            })
          )
        )
      );
    },
    renderStreamChatReact() {
      ReactDOM.render(
        this.streamChatReactApp(),
        document.getElementById('stream-chat-react')
      );
    },
  },
  mounted() {
    this.initializeChat();
  },
  async beforeDestroy() {
    try {
      if (this.channel) {
        await this.channel.stopWatching();
        console.log('stopped watching channel', this.channel);
      }
    } catch (error) {
      console.log(error);
    }
    try {
      this.chatListener.unsubscribe();
      console.log('unsubscribed from chat events');
      //if (this.chatClient) await this.chatClient.disconnectUser();
    } catch (error) {
      console.log(error);
    }
    try {
      ReactDOM.unmountComponentAtNode(
        document.getElementById('stream-chat-react')
      );
    } catch (error) {}
  },
};
</script>

<style lang="scss">
//@import '//fastly.jsdelivr.net/npm/stream-chat-react/dist/css/index.css';
@import '//fastly.jsdelivr.net/npm/stream-chat-react@10.1.1/dist/css/index.css';
@import '@/web/styles/components-variables.scss';

stream-chat-react,
#stream-chat-react,
.full-chat {
  height: 100%;
  border-left: 1px solid #e1e1e1;
  z-index: 1001;
  /*
    @media screen and (max-width: $screen-sm-min){
      border-left: none;
    }
    */
}

.str-chat {
  height: 100%;
}

.str-chat.str-chat-channel {
  /*height: calc(100vh - 105px);*/
  background-color: white;

  /*
    @media screen and (max-width: $screen-sm-min){
      height: calc(100vh - 95px);
    }

    @media screen and (max-width: $screen-sm-min) and (orientation: portrait){
      height: 35vh;
    }
    */
}

.full-chat .str-chat.str-chat-channel {
  height: 100%;
}

.str-chat__fileupload-wrapper {
  display: none;
}

.str-chat__header-hamburger,
.str-chat__input-footer,
.str-chat__header-livestream-left--members {
  display: none !important;
}

.str-chat__header-livestream {
  min-height: 50px !important;
}

.str-chat__input-flat {
  padding-left: 10px !important;
  padding-right: 10px !important;
}

.str-chat__audio__image {
  z-index: 1;
}

.str-chat__message-team--editing {
  background: $light-gray;
  box-shadow: 0 0 11px 0 rgb(0 0 0 / 6%), inset 0 1px 0 0 $light-gray,
    inset 0 -1px 0 0 $light-gray;
}

.str-chat__edit-message-form textarea {
  box-shadow: inset 0 0 0 1px $dark-gray;
}

.str-chat__edit-message-form
  .str-chat__message-team-form-footer
  button[type='submit'],
.str-chat__message-actions-list-item {
  color: $black;
}

.str-chat__message-actions-list-item:hover {
  color: $dark-gray;
}

.str-chat__input-flat-emojiselect > svg {
  transform: scale(0.7);
}

.str-chat__audio__content--progress > div {
  background: var(--brand-color) !important;
}

.str-chat__message-attachment--image {
  max-width: fit-content;
}

.str-chat__input-flat .str-chat__textarea > textarea {
  background: white;
  border: 1px solid $medium-gray;
  border-radius: $border-radius;

  &:focus {
    border-radius: $border-radius;
  }
}

.str-chat__input-flat-emojiselect {
  top: calc(100% - 48px);
}

.str-chat__input-flat .str-chat__textarea > textarea:focus {
  box-shadow: 0 0 0 1px var(--brand-color, $coral);
}

.str-chat__send-button path {
  fill: var(--brand-color, $coral);
}

.str-chat__date-separator-date {
  font-weight: $font-weight-normal;
}

// fix for overlapping message author names
.str-chat__message-data,
.str-chat__message-simple-data {
  position: static !important;
}
</style>
